import { render, staticRenderFns } from "./index-discount.vue?vue&type=template&id=ce800226&scoped=true&"
import script from "./index-discount.vue?vue&type=script&lang=js&"
export * from "./index-discount.vue?vue&type=script&lang=js&"
import style0 from "./index-discount.vue?vue&type=style&index=0&id=ce800226&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce800226",
  null
  
)

export default component.exports